import { render, staticRenderFns } from "./UserAnnouncementPage.vue?vue&type=template&id=ada28728&scoped=true"
import script from "./UserAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./UserAnnouncementPage.vue?vue&type=script&lang=js"
import style0 from "./UserAnnouncementPage.vue?vue&type=style&index=0&id=ada28728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada28728",
  null
  
)

export default component.exports